// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1UVOW","image":"Header_image__1Qc95","name":"Header_name__30edq","info":"Header_info__ck57T","infoRow":"Header_infoRow__eghKo"};